export const useShareContents = () =>
  useState<{ subject: string; bodyText: string }>('Share-Contents', () => {
    return {
      subject: '',
      bodyText: '',
    }
  })
